import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Arrange, Pill, Tooltip } from "@aviary";
import { l } from "@shared/locales/i18n";
import { Size } from "@shared/types/sizes";

const OnlyOnFullscriptTag: FC = () => {
  const { t } = useTranslation();

  return (
    <Arrange justify="center">
      <Tooltip tooltipContent={t(l.products.PillPacksTooltip)}>
        <Pill isSize={Size.SMALL} isColor="primary">
          {t(l.products.OnlyOnFullscript)}
        </Pill>
      </Tooltip>
    </Arrange>
  );
};

export { OnlyOnFullscriptTag };
